export interface BmkParseResult {
  functionalAssignment?: string;
  functionDesignation?: string;
  installationSite?: string;
  locationDesignation?: string;
  device?: string;
}

type OneOrMultipleTokens = string | string[];

export class BmkParser {
  public static parse(structure: string): BmkParseResult {
     const cutpoints = this.findTokens(structure, [
        ['==', '≠'], // FunctionalAssignment
        '=', // FunctionDesignation
        '++', // InstallationSite
        '+', // LocationDesignation
        '-' // Device
      ]);

    let functionalAssignment = this.createBmkSubtext(cutpoints[0], cutpoints, structure);
    const functionDesignation = this.createBmkSubtext(cutpoints[1], cutpoints, structure);
    const installationSite = this.createBmkSubtext(cutpoints[2], cutpoints, structure);
    const locationDesignation = this.createBmkSubtext(cutpoints[3], cutpoints, structure);
    const device = this.createBmkSubtext(cutpoints[4], cutpoints, structure);

    // FunctionalAssignment: replace alternate prefixes with '=='
    if (functionalAssignment && functionalAssignment.startsWith('≠')) {
      functionalAssignment = functionalAssignment.replace('≠', '==');
    }

    return {
      functionalAssignment: functionalAssignment.trim(),
      functionDesignation: functionDesignation.trim(),
      installationSite: installationSite.trim(),
      locationDesignation: locationDesignation.trim(),
      device: device.trim(),
    };
  }

  private static findTokens(value: string, tokens: OneOrMultipleTokens[]): number[] {
    let offset = 0;
    const result = [];

    for (const token of tokens) {
      const {tokenPos: tokenPos, newOffset: newOffset} = this.findToken(value, token, offset);
      result.push(tokenPos);
      offset = newOffset;
    }

    return result;
  }

  // Find the first matching token in value, starting from offset.
  // Returns the position of the token and a new offset to start the next token search from.
  private static findToken(value: string, token: OneOrMultipleTokens, offset: number = 0): {tokenPos: number, newOffset: number} {
    const tokens: string[] = (typeof token == "string") ? [token] : token;

    const matchedTokens = tokens
      .map(t => [t, value.indexOf(t, offset)] as const)
      .filter(([, index]) => index >= 0)
      .sort(([, index1], [, index2]) => index1 - index2);

    if (matchedTokens.length === 0) return {tokenPos: -1, newOffset: offset};

    const [matchedToken, tokenPos] = matchedTokens[0];
    return {tokenPos: tokenPos, newOffset: tokenPos + matchedToken.length};
  }

  private static createBmkSubtext(startPoint: number, cutpoints: number[], bmkText: string): string {
    if (startPoint < 0) {
      return '';
    }

    const nextPos = this.getNextAfterNumber(startPoint, cutpoints);
    return bmkText.substring(startPoint, nextPos);
  }

  private static getNextAfterNumber(value: number, others: number[]): number {
    let min = Number.MAX_VALUE;
    for (const v of others) {
      if (v <= value) {
        continue;
      }

      min = Math.min(min, v);
    }
    return min;
  }
}
